/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { connectionsGetStats } from "../../funcs/connectionsGetStats.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetConnectionStatsConnectionsConnectionIdStatsGetRequest$inboundSchema,
};

export const tool$connectionsGetStats: ToolDefinition<typeof args> = {
  name: "connections-get-stats",
  description: `Get Connection Stats

Lists connection stats: total documents active documents, total active pages.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await connectionsGetStats(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
